// Vendor imports
// import $ from './lib/jquery.init'; //jQuery is being included on footer_UI.isml

// Custom imports
window.BORN = window.BORN || {
	'$body': $(document.body)
};

__webpack_public_path__ = window.Urls.staticPath + 'js/';

import Router from './helpers/router';
import Header from './modules/sections/header';
import Footer from './modules/sections/footer';

Router();
Header();
Footer();


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/main.js